module.exports = __webpack_public_path__ + "static/gem_of_brightness-41aa5e88e8f3ceb2134da51d99f352ef.jpeg";